"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var e=function(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e};exports.default=e;
